// SEO Meta data por ruta
export const seoData = {
  '/': {
    title: 'KOMPA - Ahorra con Propósito y Logra tus Metas',
    description: 'Kompa es la plataforma de ahorro con propósito que te ayuda a lograr tus metas. Recibes hasta el 15% de vuelta. Sin intereses bancarios. 100% indexado y resguardado.',
    keywords: 'ahorro, metas financieras, ahorro con propósito, kompa, finanzas personales, ahorro inteligente',
    ogImage: 'https://customer-assets.emergentagent.com/job_kompa-landing/artifacts/nndf0ac2_edited-photo.png',
    canonical: 'https://kompa.com'
  },
  '/como-funciona': {
    title: 'Cómo Funciona KOMPA - El Camino hacia tu META',
    description: 'Descubre cómo KOMPA te ayuda a lograr tus metas en 3 pasos: Imagínalo, Konstruyelo, Lógralo. Ahorra con propósito y recibe hasta el 15% de vuelta.',
    keywords: 'como funciona kompa, ahorro paso a paso, metas financieras, proceso de ahorro',
    ogImage: 'https://customer-assets.emergentagent.com/job_kompa-landing/artifacts/nndf0ac2_edited-photo.png',
    canonical: 'https://kompa.com/como-funciona'
  },
  '/precios': {
    title: 'Planes y Precios KOMPA - Personaliza tu Meta',
    description: 'Elige entre Ahorro Total o Ahorra entre Kompas. Personaliza tu plan: monto, frecuencia de pago y tiempo. Kompa cobra 1.5% mensual en planes de 6 meses o menos, 1% en planes mayores.',
    keywords: 'planes kompa, precios ahorro, ahorro total, ahorra entre kompas, calculadora de ahorro',
    ogImage: 'https://customer-assets.emergentagent.com/job_kompa-landing/artifacts/nndf0ac2_edited-photo.png',
    canonical: 'https://kompa.com/precios'
  },
  '/kompa-club': {
    title: 'Metas KOMPA - Motos, Vehículos, Educación y Más',
    description: 'Elige la META que quieres lograr: Motos, Vehículos, Ferretería, Educación, Navidades, Salud. Diferentes metas para diferentes momentos de la vida.',
    keywords: 'metas kompa, ahorro para motos, ahorro para vehiculos, ahorro educacion, ahorro salud',
    ogImage: 'https://customer-assets.emergentagent.com/job_kompa-landing/artifacts/nndf0ac2_edited-photo.png',
    canonical: 'https://kompa.com/kompa-club'
  },
  '/faq': {
    title: 'Preguntas Frecuentes - KOMPA',
    description: 'Resolvemos tus dudas sobre KOMPA. ¿Cómo funciona? ¿Es seguro mi dinero? ¿Qué son los grupos entre kompas? Atención 24/7.',
    keywords: 'preguntas frecuentes kompa, faq kompa, dudas kompa, ayuda kompa',
    ogImage: 'https://customer-assets.emergentagent.com/job_kompa-landing/artifacts/nndf0ac2_edited-photo.png',
    canonical: 'https://kompa.com/faq'
  }
};

export const defaultSeo = seoData['/'];
